/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap-v5';
import { Redirect, Route, Switch } from 'react-router-dom';

import { ForgotPassword } from './components/ForgotPassword';
import { Login } from './components/Login';
import { Registration } from './components/Registration';
import { ConfirmLocation } from './components/confirmLocation';

export function AuthPage() {
  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => {
      document.body.classList.remove('bg-white')
    }
  }, [])

  return (
    <Row className='h-100 overflow-auto g-0'>
      <Col sm={12} md={7}>
        <div className='bg-white p-10 p-lg-15 mx-auto col-md-9'>
          <Switch>
            <Route path='/auth/login' component={Login} />
            <Route path='/auth/registration' component={Registration} />
            <Route path='/auth/forgot-password' component={ForgotPassword} />
            <Route path='/map-picker/:code' component={ConfirmLocation} />
            <Redirect from='/auth' exact={true} to='/auth/login' />
            <Redirect to='/auth/login' />
          </Switch>
        </div>
      </Col>
      <Col
        className='d-none d-sm-block'
        md={5}
        style={{backgroundImage: `url("/assets/images/banner/login-banner.png")`, backgroundSize: "cover"}}
      >
        
      </Col>
    </Row>
  )
}
